var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,11.46a.37.37,0,0,0,0-.14.14.14,0,0,0,0-.07,0,0,0,0,1,0,0l-.11-.11,0,0L20,8.49V.5a.5.5,0,0,0-.5-.5H4.5A.5.5,0,0,0,4,.5v8L.23,11.08h0l-.12.12a0,0,0,0,1,0,0,.14.14,0,0,0,0,.07.37.37,0,0,0,0,.14s0,0,0,0V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V11.5S24,11.48,24,11.46Zm-1.38,0L20,13.23V9.7ZM4,13.23,1.39,11.49,4,9.7ZM22,23H2a1,1,0,0,1-1-1V12.43l5.22,3.49A.57.57,0,0,0,6.5,16a.52.52,0,0,0,.42-.22.51.51,0,0,0-.14-.7L5,13.9V1H19V13.9l-1.78,1.18a.51.51,0,0,0-.14.7.52.52,0,0,0,.42.22.57.57,0,0,0,.28-.08L23,12.43V22A1,1,0,0,1,22,23Zm-1.19-2.89a.5.5,0,0,1,.08.7.48.48,0,0,1-.39.19.51.51,0,0,1-.31-.11L15.32,17H8.68L3.81,20.89a.5.5,0,0,1-.62-.78l5-4A.51.51,0,0,1,8.5,16h7a.51.51,0,0,1,.31.11ZM7,3.5A.5.5,0,0,1,7.5,3h2a.5.5,0,0,1,0,1h-2A.5.5,0,0,1,7,3.5ZM9.5,6h7a.5.5,0,0,1,0,1h-7a.5.5,0,0,1,0-1ZM7,9.5A.5.5,0,0,1,7.5,9h9a.5.5,0,0,1,0,1h-9A.5.5,0,0,1,7,9.5Zm0,3a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,0,1h-9A.5.5,0,0,1,7,12.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeOpen);
export default __webpack_public_path__ + "static/media/envelope-open.1947daf55a3deaa3dbb94c78bdd3eb90.svg";
export { ForwardRef as ReactComponent };